import brandPortalMessages from "@faire/web-api/routes/brand-portal/messages";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../../common/Bold";
export var SWFShipped = function SWFShipped() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ha1Fly",
    defaultMessage: [{
      "type": 0,
      "value": "This order has been marked as shipped, so you can no longer edit the tracking information. When a Ship with Faire label has been used or the shipment is already in transit, you won’t be able to cancel the label and create a new one. Reach out to our Support team for help, so your retailer receives the correct information."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "u33Ad+",
    defaultMessage: [{
      "type": 0,
      "value": "Additionally, you can send a message to the retailer via "
    }, {
      "children": [{
        "type": 0,
        "value": "Faire messenger"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " to provide correct shipping information."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return FaireMessagingFormatting(chunks);
      }
    }
  })));
};
var FaireMessagingFormatting = function FaireMessagingFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMessages(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};